import React from 'react'
import CashZoneButton from '../CashZoneButton'
import PaginationButtons from '../PaginationButtons'
import CashButton from '../CashButton'
import BettingPageFilteFields from '../BettingPageFilteFields'

const BettingPageComponent = () => {
    return (
        <>
            <div className='pb-[100px] lg:pb-0'>
                <BettingPageFilteFields />
                <div className='pt-5 lg:py-2.5'>
                    <PaginationButtons  totalPages={1} currentPage={1}/>
                </div>
                <div className='lg:border-t border-slate'>
                    <div className='lg:pt-5'>
                        <div className="hidden lg:block"><CashButton label="베팅내역 올리기" /></div>
                        <div className="lg:hidden betting-cash-btn-container"><CashButton label="내역 올리기" /></div>
                    </div>
                    <div className='w-fit mx-auto text-center lg:me-0 lg:ms-auto'>
                        <select className='me-1 border text-white text-xs h-[38px] leading-[38px] transition-[0.2s] align-middle px-[5px] py-0.5 lg:rounded-[5px] border-solid border-slate bg-obsidian outline-none lg:focus:border-indigoBlue focus:border-[#ffcc00]'  >
                            <option value="">복사할 게시판선택</option>
                            <option value="6">1:1고객센터</option>
                        </select>
                        <CashZoneButton label="복사하기" link_src="#" active_color="bg-[#153cb8]" active={false} type="button" />
                        <CashZoneButton label="선택삭제" link_src="#" active_color="bg-[#153cb8]" active={true} type="button" />
                        <CashZoneButton label="전체삭제" link_src="#" active_color="bg-[#153cb8]" active={true} type="button" />
                    </div>
                </div>
            </div>
        </>
    )
}

export default BettingPageComponent